module.exports = __webpack_public_path__ + "img/chevron-down-orange.9b36119b.svg";